module.exports = __webpack_public_path__ + "img/pc_banner_support.529ce9ef.png";